angular.module('app').factory('skinService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/skin/");

        return {
            getAllSkins: function (requestData) {
                return restAngular.
                    one("get").
                    customGET(param(requestData))
            },
            editSkin: function (requestData) {
                return restAngular.
                    one("change").
                    post("", requestData)
            },
            getSkinById: function (requestData) {
                return restAngular.
                    one("get").
                    customGET(param(requestData))
            },
            deleteSkin: function (requestData) {
                return restAngular.
                    one("delete").
                    customGET(param(requestData))
            },
            retest: function (requestData) {
                return restAngular.
                    one("reset").
                    post("", requestData)
            }
        }
    }
]);